module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"oneTime":"einmalig","month":"monatlich","from":"ab"},"en":{"oneTime":"one-time","month":"monthly","from":"from"}}')
  delete Component.options._Ctor
}
